import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CustomerAppShell from '../app/shells/customerAppShell';
import StaffAppShell from '../app/shells/staffAppShell';
import { getDeploySurface } from '../lib/deploySurface';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function RootLayout() {
  const surface = getDeploySurface();
  const useCustomerShell = surface === 'website' || surface === 'customer';
  return (
    <>
      <ScrollToTop />
      {useCustomerShell ? <CustomerAppShell /> : <StaffAppShell />}
    </>
  );
}
